// extracted by mini-css-extract-plugin
export default {"app":"src-containers-App--app","appContent":"src-containers-App--appContent"};